import { configureStore } from '@reduxjs/toolkit';
import authReducer from "./slices/authSlice";

import { authApi } from './api/authApi';
import { userApi } from './api/userApi';
import { campusApi } from './api/campusApi';
import { categoryApi } from './api/categoryApi';
import { vendorApi } from './api/vendorApi';
import { inventoryApi } from './api/inventoryApi';
import { requestApi } from './api/requestApi';
import { allotmentApi } from './api/allotmentApi';
import { reportsApi } from './api/reportsApi';
import { roleApi } from './api/roleApi';
import { notificationApi } from './api/notificationApi';
import { activityApi } from './api/activityApi';
import { staticApi } from './api/staticApi';

const apis = [
  authApi, userApi, campusApi, categoryApi, vendorApi,
  inventoryApi, requestApi, allotmentApi, reportsApi,
  roleApi, notificationApi, activityApi, staticApi
];

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ...Object.fromEntries(apis.map(api => [api.reducerPath, api.reducer])),
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apis.map(api => api.middleware).flat()),
});